import { useEffect, useState } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";
// utilities
import { innerLanguageVersion, metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";
import useContent from "@/hooks/useContent";
import RMDRImage from "@/components/RMDRImage";
import EResourceType from "@/cms/enums/EResourceType";


const unqKey = nanoid(12);
const Page404 = () => {
    console.log("Page404.rendered");

    const { siteSettingPayload, _showLoader, _hideLoader } = useOutletContext<TOutletContext>();
    const [ contentId ] = useState(metaDataLanguageVersion("404PageId", siteSettingPayload.languageVersions));
    const content = useContent({ unqKey, id:contentId });

    useEffect(
        () => {
            const element = document.getElementsByClassName("navbar-style-2")?.[0];
            if ( element ) {
                element.classList.remove("navbar-style-2");
                element.classList.add("dark-navbar");
            }
            return () => { _showLoader(); }
        }, []
    )

    if ( !content || isEmpty(content) ) return null;

    _hideLoader();

    const languageVersion = outerNameDescriptionLanguageVersion(content.languageVersions);
    const languageVersionInner = innerLanguageVersion(content.languageVersions);

    return (
        <div className="error-area">
            <div className="container">
                <div className="error-content">
                    <RMDRImage
                        resourceType={EResourceType.INNER_IMAGE}
                        resources={content.resources} 
                        alt={languageVersion?.name}
                        title={languageVersion?.name}
                    />
                    <RMDRComponentSanitizer className="error-message" languageVersion={languageVersionInner} variant="div" />
                </div>
            </div>
        </div>
    )
}

export default Page404;
